import React, { useState } from "react";

const KidsCards = ({ ImgSrc, ImgJpg, title, desc, isDesktop, item, showWishlistButton }) => {
  const [currentImg, setCurrentImg] = useState(ImgSrc);
  const [loaded, setLoaded] = useState(false); // Track when image loads
  const [imageError, setImageError] = useState(false); // Track if primary image failed

  const imageWrapperClass = `aspect-square w-full overflow-hidden rounded-xl relative group transition-shadow duration-500 ${
    loaded ? 'shadow-xl shadow-gray-400' : 'shadow-none'
  }`;

  const imageClass = `w-full h-full object-cover rounded-xl transition-all duration-300 group-hover:scale-105 group-hover:rounded-none`;

  // Handle image load error and fallback to jpg
  const handleImageError = () => {
    if (!imageError && ImgJpg) {
      setCurrentImg(ImgJpg);
      setImageError(true);
    }
  };

  // Handle successful image load
  const handleImageLoad = () => {
    setLoaded(true);
  };

  const desktopWrapper = (
    <div className="w-[350px] lg:w-[380px]">
      <button className="w-full">
        <div className={imageWrapperClass}>
          <img
            className={imageClass}
            src={currentImg}
            alt={title}
            onLoad={handleImageLoad}
            onError={handleImageError}
          />
        </div>
        <div className="p-3 text-center">
          <p className="text-gray-500 text-xs pt-0">{title}</p>
          <p className="text-gray-700 text-base pt-0">{desc}</p>
        </div>
      </button>
    </div>
  );

  const mobileWrapper = (
    <div className="w-full">
      <button className="w-full">
        <div className={imageWrapperClass}>
          <img
            className={imageClass}
            src={currentImg}
            alt={title}
            onLoad={handleImageLoad}
            onError={handleImageError}
          />
        </div>
        <div className="p-2 text-center">
          <p className="text-gray-500 text-xs pt-0">{title}</p>
          <p className="text-gray-800 text-base pt-0">{desc}</p>
        </div>
      </button>
    </div>
  );

  return isDesktop ? desktopWrapper : mobileWrapper;
};

export default KidsCards;
